import React from 'react'

function MyClose({fillColor}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill={fillColor} viewBox="0 0 24 24" width="34" height="34" aria-hidden="true" focusable="false"><path d="M13 11.8l6.1-6.3-1-1-6.1 6.2-6.1-6.2-1 1 6.1 6.3-6.5 6.7 1 1 6.5-6.6 6.5 6.6 1-1z"></path></svg>
  )
}

export default MyClose